import React from 'react';

const Footer = (props) => (
    <div className="footer-sec">
        <p className='text-center'>SMS lynkit</p>
    </div>
);

export default Footer